import { default as domainTeacherIndicator } from './indicator/store'
import { default as teacherPositionCategory } from './position-category/store'
import { default as domainActivityOfferedComponent } from './activity-offered-component/store'
import { default as domainActivityOfferedModality } from './activity-offered-modality/store'
import { default as domainActivityOffered } from './activity-offered/store'

export default {
	domainTeacherIndicator,
	teacherPositionCategory,
	domainActivityOfferedComponent,
	domainActivityOfferedModality,
	domainActivityOffered
}